module.exports = __webpack_public_path__ + "static/img/avatar_2.c44ffcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/avatars/avatar_2.png
// module id = Vjpm
// module chunks = 0